import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctValue } from '../../../../Fct/generics';
import { FaArrowDown } from 'react-icons/fa';
import { getAaveV3Tokens } from '../../allowanceRequiredProtocols';
import { POOL_ADDRESSES } from '../constants';
export var Withdraw = createPlugin({
    protocol: 'AaveV3',
    type: 'ACTION',
    method: 'withdraw',
    supportedContracts: POOL_ADDRESSES,
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({ destination: 'aave_pool_v3' }),
                methodParams: {
                    asset: new FctAddress({ destination: 'erc20', options: getAaveV3Tokens({ chainId: chainId }), isPreview: true, icon: FaArrowDown }),
                    amount: new FctValue({ destination: 'wei_amount', isPreview: true }),
                    to: new FctAddress({}),
                },
            },
            output: {
                amountWithdrawn: new FctValue({ innerIndex: 0 }),
            },
        });
    },
});
